module.exports = __webpack_public_path__ + "img/@logo_starfilde@3x.998e3499.png";